<app-site-header />

<embed type="application/pdf" [src]="pdfDoc | safe: 'resourceUrl'" width="100%" height="100%" />